"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountrySelectField = void 0;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _reactSelect = require("react-select");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Form = require("../Form");

var _helpers = require("../../../domains/countries/helpers");

var _validationSchema = require("../../../helpers/validationSchema");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * The only way to change the native properties of the input element in react-select is to pass a
 * custom input component with different props. The reason is these properties are hardcoded in the
 * input specification in the library.
 *
 * https://github.com/JedWatson/react-select/issues/3500#issuecomment-480410333
 *
 * The reason for this fix is because chrome ignores the property autocomplete="off" and for this
 * use case, we really need to disable autocomplete.
 *
 * For more information about Google decision on ignoring autocomplete, check:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=468153#c164
 */
var InputCountry = function InputCountry(_ref) {
  var autoComplete = _ref.autoComplete,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["autoComplete"]);
  return __jsx(_reactSelect.components.Input, (0, _extends2["default"])({}, props, {
    autoComplete: "fixing-autocomplete"
  }));
};

var CountryFlag = _styledComponents["default"].img.withConfig({
  displayName: "CountrySelect__CountryFlag",
  componentId: "bqce89-0"
})(["width:20px;margin-right:10px;height:20px;background-color:transparent;border-radius:4px;"]);

var OptionCountry = function OptionCountry(_ref2) {
  var children = _ref2.children,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["children"]);
  var name = props.data.name;
  var countryFlagSrc = (0, _helpers.getFlagSrc)(name);
  return __jsx(_reactSelect.components.Option, props, __jsx(CountryFlag, {
    src: countryFlagSrc,
    alt: ""
  }), " ", children);
};

function getCountryOptionLabel(country) {
  return country.name;
}

function getCountryOptionValue(country) {
  return country.slug;
}

var CountrySelectField = function CountrySelectField(_ref3) {
  var countries = _ref3.countries,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["countries"]);
  return __jsx(_styledComponents.ThemeConsumer, null, function (theme) {
    return __jsx(_styledComponents.ThemeProvider, {
      theme: {
        withSearchIcon: theme.variant === 'outline'
      }
    }, __jsx(_Form.SelectField, (0, _extends2["default"])({
      "data-testid": "country-select-field",
      components: {
        Input: InputCountry,
        Option: OptionCountry
      },
      getOptionLabel: getCountryOptionLabel,
      getOptionValue: getCountryOptionValue,
      options: countries
    }, props)));
  });
};

exports.CountrySelectField = CountrySelectField;